module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textNum)
    }
  }), _vm._v(" "), (_vm.item.resourceType === _vm.ResType_Zaixianzuoda) ? _c('span', {
    staticStyle: {
      "padding-right": "10px"
    }
  }, [_vm._v("\n      已选  \n      "), _c('i', {
    staticStyle: {
      "color": "#01B98F",
      "padding-right": "3px"
    }
  }, [_vm._v(_vm._s(_vm.item.bigItemCount))]), _vm._v("个大题\n    ")]) : _vm._e(), _vm._v(" "), (_vm.item.resourceType === _vm.ResType_DanCiGenDu || _vm.item.resourceType === _vm.ResType_Xuanzeduanluo || _vm.moduleId == 15 || _vm.moduleId == 30 || _vm.moduleId == 66 || _vm.item.resourceType === _vm.ResType_Zaixianzuoda) ? _c('span', [_vm._v("\n         预计\n      "), _c('i', {
    staticStyle: {
      "color": "#00ba8f",
      "padding": "0px 3px"
    }
  }, [_vm._v(_vm._s(_vm.readTime))]), _vm._v("分钟\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "choice clear"
  }, [(_vm.moduleId == 10 || _vm.moduleId == 127) ? _c('div', {
    staticClass: "selectSpeek"
  }, [_c('origin-select', {
    attrs: {
      "data": _vm.speektypes,
      "selectObj": "types",
      "defValue": _vm.typesId
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleId == 10 || _vm.moduleId == 127) ? _c('div', {
    staticClass: "selectRead"
  }, [_c('origin-select', {
    attrs: {
      "data": _vm.readTimes,
      "selectObj": "times",
      "defValue": _vm.timesId
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82a21dc8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chooseText/chooseText.vue
// module id = 1227
// module chunks = 1